import { useEffect, useState } from 'react'

const IMPERSONATION_STORAGE_KEY = 'impersonate-user-id'

const listeners = new Set<() => void>()

const notifyImpersonationChange = () => {
  listeners.forEach(listener => listener())
}

export const getImpersonatedUserId = (): string | null => {
  return sessionStorage.getItem(IMPERSONATION_STORAGE_KEY)
}

export const setImpersonatedUserId = (userId: string) => {
  sessionStorage.setItem(IMPERSONATION_STORAGE_KEY, userId)
  notifyImpersonationChange()
}

export const clearImpersonation = () => {
  sessionStorage.removeItem(IMPERSONATION_STORAGE_KEY)
  notifyImpersonationChange()
}

export const useImpersonatedUserId = () => {
  const [impersonatedUserId, setImpersonatedUserIdState] = useState<string | null>(() => getImpersonatedUserId())

  useEffect(() => {
    const listener = () => setImpersonatedUserIdState(getImpersonatedUserId())
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  }, [])

  return impersonatedUserId
}

const IMPERSONATION_SCOPED_PATH_PREFIXES = [
  '/users/me',
  '/user-pkg',
  '/user-pickup-orders',
  '/addresses',
  '/payments/',
  '/coupons/check',
  '/preqs',
] as const

export const shouldAttachImpersonationHeader = (url?: string): boolean => {
  if (!url) {
    return false
  }

  const path = url.startsWith('http') ? new URL(url).pathname : url
  return IMPERSONATION_SCOPED_PATH_PREFIXES.some(prefix => path.includes(prefix))
}

export const IMPERSONATE_USER_ID_HEADER = 'X-Impersonate-User-Id'
